import { BackgroundColors, PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/rc/fonts';

export default createUseStyles<string, { img: string }>(
  {
    itemContainer: {
      '@media screen and (max-width: 768px)': {
        maxWidth: 167,
        maxHeight: 210,
      },
      itemWrapper: {
        marginTop: Spacings.s24,
        marginBottom: Spacings.s72,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '@media screen and (max-width: 425px)': {
          padding: Spacings.s10,
        },
      },
    },
    wrapper: {
      background: PositiveColors.base.default,
      border: `2px solid ${BackgroundColors.tint2}`,
      borderRadius: CornerRadius.r24,
      padding: Spacings.s24,
      transition: 'all 0.15s ease-out',
      '@media screen and (max-width: 768px)': {
        padding: Spacings.s12,
      },
      '&:hover': {
        boxShadow: '0px 0px 16px 0px rgba(104, 10, 255, 0.30)',
      },
    },
    imgContainer: {
      borderRadius: CornerRadius.r8,
      background: 'rgba(216, 197, 247, 1)',
      height: 212,
      width: 220,
      textAlign: 'center',
      cursor: 'pointer',
      display: 'block',
      overflow: 'hidden',
      position: 'relative',
      '@media screen and (max-width: 768px)': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 142,
        width: 148,
        '& span': {
          maxHeight: 124,
        },
      },
      '&:hover': {
        background: 'rgba(216, 197, 247, 1)',
      },
      '&:after': {
        content: '""',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: 'linear-gradient(35deg, transparent 52%, rgb(255 255 255 / 20%) 52%);',
        pointerEvents: 'none',
      },
    },

    img: {
      objectFit: 'cover',
      maxWidth: '100%',
      borderRadius: CornerRadius.r24,
      '@media screen and (max-width: 768px)': {
        maxWidth: 112,
        maxHeight: 124,
      },
    },

    sizeItemName: {
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.SemiBold,
      lineHeight: LineHeights.l28,
      color: PositiveColors.text.default,
      marginTop: Spacings.s16,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',

      '@media screen and (max-width: 768px)': {
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
      },
    },

    badge: {
      position: 'absolute',
      left: Spacings.s8,
      top: Spacings.s8,
    },
  },
  { name: 'Item' },
);
